import React from 'react';
import { GelRowLayout, GelColumnLayout} from '@tal-gel/components';
import { get } from 'lodash';
import { boldLabel, defaultH3Text } from '../Shared/Styles';

export default function ContactDetails(props) {
    const policyLife = props.insuredParty;

    return (
        <GelRowLayout>
            <GelRowLayout gutter="small">
                <h3 style={defaultH3Text} data-testid="ContactDetailsLabel">Contact Details</h3>
            </GelRowLayout>

            <GelRowLayout gutter="small" style={{marginBottom: '0'}}>
                <GelColumnLayout distribution="1/2 1/2">
                    <div style={boldLabel}>Address:</div>
                    <div style={boldLabel}>Telephone:</div>
                </GelColumnLayout>

                <GelColumnLayout distribution="1/2 1/2">
                    <div data-testid="address">{get(policyLife, 'contactDetails.address', '')}</div>
                    <div data-testid="telephone">{get(policyLife, 'contactDetails.telephone', '')}</div>
                </GelColumnLayout>
            </GelRowLayout>
        </GelRowLayout>
    );
}